import ChangeCourseActionTypes from './changeCourse.types';

export const getAllCourses = () => ({
	type: ChangeCourseActionTypes.FETCH_COURSES.PENDING,
});

export const changeActiveCourse = (courseId, callback = '') => ({
	type: ChangeCourseActionTypes.CHANGE_ACTIVE_COURSE.PENDING,
	payload: { courseId, callback },
});
